import { CheckPasswordInterface } from '../../models/check-password.interface';

export interface CheckPasswordInterfaceState {
  result: CheckPasswordInterface;
}

export const initialCheckPasswordState: CheckPasswordInterfaceState = {
  result: null
};
